import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Table } from 'semantic-ui-react';
import CopyContentComponent from '../../../misc/CopyContent.component';
import { AuthorizedRepresentativeView } from '../../../../types/AuthorizedRepresentative';

type AuthorizedRepresentativeProps = {
    data?: AuthorizedRepresentativeView[];
    copy?: boolean;
};
export default function LeadAuthorizedRepresentativeComponent(
    authorizedRepresentativeProps: AuthorizedRepresentativeProps
): React.ReactElement {
    const { t } = useTranslation();

    function createValue(value?: string): React.ReactElement {
        return authorizedRepresentativeProps.copy ? (
            <CopyContentComponent>{value || ''}</CopyContentComponent>
        ) : (
            <>{value || ''}</>
        );
    }

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header content={t('lead.detail.box.company.authorizedRepresentatives.headline')} />
                <Card.Description>
                    <Table celled striped columns={3}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell
                                    content={t('lead.detail.box.company.authorizedRepresentatives.person.firstName')}
                                />
                                <Table.HeaderCell
                                    content={t('lead.detail.box.company.authorizedRepresentatives.person.lastName')}
                                />
                                <Table.HeaderCell
                                    content={t('lead.detail.box.company.authorizedRepresentatives.person.role')}
                                />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {authorizedRepresentativeProps.data?.map((value, index) => (
                                <Table.Row key={index}>
                                    <Table.Cell singleLine content={createValue(value.firstName)} />
                                    <Table.Cell singleLine content={createValue(value.lastName)} />
                                    <Table.Cell content={createValue(value.role.join(', '))} />
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Card.Description>
            </Card.Content>
        </Card>
    );
}
